import { storage } from "firebase/app";
import { toastr } from "react-redux-toastr";

export function getLatestFileUrl(id, document, path) {
  const storageRef = storage().ref();

  let currentPath = path;
  let isObjectNotFound = false;

  const processFileRef = () => {
    toastr.info("Opening file. Please wait");
    console.log("opening file");

    if (isObjectNotFound) {
      currentPath = path === "documents" ? "attachments" : "documents";
    }
    const fileRef = storageRef.child(
      `${id}/${currentPath}/${document.fileName}`
    );
    fileRef
      .getDownloadURL()
      .then((url) => {
        var xhr = new XMLHttpRequest();
        xhr.responseType = "blob";
        xhr.onload = (event) => {
          var blob = xhr.response;
          const link = window.document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.target = "_blank";
          link.click();
        };
        xhr.open("GET", url);
        xhr.send();
      })
      .catch((err) => {
        if (err.code === "storage/object-not-found") {
          isObjectNotFound = true;
          processFileRef();
        } else {
          toastr.error(`Error in opening link. ${err.message}`);
        }
        console.log(err);
      });
  };
  processFileRef();
}
